export default "__VITE_ASSET__B_veze6i__"